import { OdataFieldTwoValueOperator } from './OdataFieldTwoValueOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldOperatorConcat extends OdataFieldTwoValueOperator {
  constructor(field: IOdataField, concatValue: IOdataField) {
    super(field, concatValue, 'concat');
  }
}
